import React from 'react';
import { Box } from '@mui/material';


interface WatercolorContainerProps {
  children: React.ReactNode;
  className?: string;
  disableMargin?: boolean;
}

const WatercolorContainer: React.FC<WatercolorContainerProps> = ({ children, className, disableMargin }) => {
  return (
    <Box
      className={className}
      sx={{
        position: 'relative',
        margin: disableMargin ? 0 : { xs: 0, md: 3 },
        overflow: 'hidden',
        minHeight: 0,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  );
};

export default WatercolorContainer;
